import api from '@/services/Api';

class References {
  static create(nominationId, payload) {
    return api.post(`/awards/nomination/${nominationId}/references`, payload);
  }

  static all(params) {
    return api.get('/awards/references', {
      params,
    });
  }

  static get(id, params) {
    return api.get(`/awards/references/${id}`, {
      params,
    });
  }

  static update(id, payload) {
    return api.put(`/awards/references/${id}`, payload);
  }

  static select(id) {
    return api.post(`/awards/references/${id}/select`);
  }

  static unselect(id) {
    return api.post(`/awards/references/${id}/unselect`);
  }

  static submit(id, payload) {
    return api.post(`/awards/references/${id}/submit`, payload);
  }
}

export default References;
